import { render, staticRenderFns } from "./EmployeesSliceForm.vue?vue&type=template&id=5b0e0366&scoped=true&"
import script from "./EmployeesSliceForm.vue?vue&type=script&lang=js&"
export * from "./EmployeesSliceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0e0366",
  null
  
)

export default component.exports